<template>
  <span class="scaling-svg-container">
    <svg
      class="scaling-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="14.376"
      height="14.377"
      viewBox="0 0 14.376 14.377"
    >
      <path
        d="M5.391,14.377h0l-.1-.006a.9.9,0,0,1-.794-.892l0-2.322L1.534,14.113a.9.9,0,0,1-1.27,0,.9.9,0,0,1,0-1.27L3.209,9.9.895,9.884a.9.9,0,0,1,0-1.8l4.493.022a.9.9,0,0,1,.895.9l0,4.469A.9.9,0,0,1,5.391,14.377Zm8.086-8.087h0l-4.47,0a.9.9,0,0,1-.9-.895L8.087.9a.9.9,0,1,1,1.8-.009L9.895,3.21,12.841.264a.9.9,0,0,1,1.272,1.27L11.155,4.492h2.323a.9.9,0,1,1,0,1.8Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PairIcon extends Vue {}
</script>

<style>
</style>
